"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Theme = _interopRequireDefault(require("./Theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var colors = {
  codeBackground: "#2B2B2B",
  codeForeground: "#A9B7C6",
  codeComment: "#619647",
  codeString: "#A5C25C",
  codeKeyword: "#CB772F",
  codeNumber: "#6897BB",
  codeFunction: "#A9B7C6",
  codeOperator: "#A9B7C6",
  codeClass: "#A9B7C6",
  codePunctuation: "#A9B7C6"
};

var _default = new _Theme["default"]({}, {
  color: colors
});

exports["default"] = _default;